import { createContext } from "react";
import { Championship } from "../types";
const data = {
	onJoinClick: null as Function,
	onPayClicked: null as Function,
	modal: null,
	championship: null as Championship,
	context: null as Function,
};
export type ChampionshipContext = typeof data;

const ChampionshipContext = createContext(data);

export default ChampionshipContext;
